/**
 * The toast shown after an archive/multi-file upload is consolidated into its tiers.
 * Names ALL THREE tiers (L0 lossless · L1 clean · L2 story) so the user isn't confused by an
 * apparent "missing L1" — every consolidation produces L0/L1/L2 (CONTEXT.md §27.0 [27.0.1]).
 * Pure + exported so it's unit-testable (capability leaf `consolidation-notice-names-tiers`).
 *
 * @param {{filesIncluded:number, fileName:string, base:string, filesSetAside?:number,
 *          l2Pending?:boolean, l2InputTruncated?:boolean}} p
 * @returns {string}
 */
export function buildConsolidationNotice({
  filesIncluded,
  fileName,
  base,
  filesSetAside = 0,
  l2Pending = false,
  l2InputTruncated = false,
}) {
  let msg =
    `Consolidated ${filesIncluded} file(s) from ${fileName} → ` +
    `${base}-L0 (knowledge-lossless) + ${base}-L1 (de-duplicated clean) + ${base}-L2 (big-picture story)`;
  if (filesSetAside) msg += ` — ${filesSetAside} non-text file(s) set aside (noted, not dropped)`;
  if (l2Pending) msg += '. Story pass pending — re-tag to retry';
  else if (l2InputTruncated) msg += '. Story built from the first portion (very large bundle)';
  return msg + '.';
}
